class MediaTooltip extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    if (!this.els?.trigger?.exists) return
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.els.trigger.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
  }

  handleTrigger () {
    this.els.trigger.elements.forEach(triggerEl => {
      triggerEl.setAttribute(
        'aria-hidden',
        triggerEl.getAttribute('aria-hidden') === 'false',
      )
    })
  }
}

if (!customElements.get('media-tooltip')) {
  customElements.define('media-tooltip', MediaTooltip)
}
